(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadeys-ingredient-library"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const libraries = document.querySelectorAll('[data-ingredient-library]');

    libraries.forEach((library) => {
      const index = library.querySelector('[data-ingredient-index]');
      const profileView = library.querySelector('[data-ingredient-profile-view]');
      const profileContent = library.querySelector('[data-ingredient-profile-content]');
      const missing = library.querySelector('[data-ingredient-missing]');

      const getLibraryUrl = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('ingredient');
        return url;
      };

      const searchInput = library.querySelector('[data-ingredient-search]');
      const clearButton = library.querySelector('[data-search-clear]');
      const suggestions = library.querySelector('[data-search-suggestions]');
      const suggestionButtons = library.querySelectorAll('[data-search-suggestion]');
      const filterButtons = library.querySelectorAll('[data-filter]');
      const cards = library.querySelectorAll('[data-ingredient-card]');
      const categorySections = library.querySelectorAll('[data-category-section]');
      const emptyState = library.querySelector('[data-search-empty]');
      const searchStatus = library.querySelector('[data-search-status]');
      let debounceTimer;

      const normalize = (value) => value
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

      const updateSearchUrl = () => {
        const url = getLibraryUrl();
        const query = searchInput.value.trim();
        const activeFilters = [...filterButtons]
          .filter((button) => button.getAttribute('aria-pressed') === 'true')
          .map((button) => button.dataset.filter);

        if (query) url.searchParams.set('q', query);
        else url.searchParams.delete('q');
        if (activeFilters.length) url.searchParams.set('filters', activeFilters.join(','));
        else url.searchParams.delete('filters');
        window.history.replaceState(window.history.state, '', url);
      };

      const applySearch = (updateUrl = true) => {
        const query = normalize(searchInput.value);
        const activeFilters = [...filterButtons]
          .filter((button) => button.getAttribute('aria-pressed') === 'true')
          .map((button) => button.dataset.filter);
        let visibleCount = 0;

        cards.forEach((card) => {
          const searchText = normalize(card.dataset.searchText || '');
          const filterTags = (card.dataset.filterTags || '').split(',').filter(Boolean);
          const matchesQuery = !query || searchText.includes(query);
          const matchesFilters = activeFilters.every((filter) => filterTags.includes(filter));
          card.hidden = !(matchesQuery && matchesFilters);
          if (!card.hidden) visibleCount += 1;
        });

        categorySections.forEach((section) => {
          const hasResults = [...section.querySelectorAll('[data-ingredient-card]')].some((card) => !card.hidden);
          section.hidden = !hasResults;
          const navItem = library.querySelector(`[data-category-link="${CSS.escape(section.dataset.categorySection)}"]`);
          if (navItem) navItem.hidden = !hasResults;
        });

        clearButton.hidden = !searchInput.value;
        suggestions.hidden = Boolean(searchInput.value);
        emptyState.hidden = visibleCount !== 0;
        searchStatus.textContent = `${visibleCount} ingredient${visibleCount === 1 ? '' : 's'} found`;
        if (updateUrl) updateSearchUrl();
      };

      const scheduleSearch = () => {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(() => applySearch(), 160);
      };

      const initialUrl = new URL(window.location.href);
      searchInput.value = initialUrl.searchParams.get('q') || '';
      const initialFilters = (initialUrl.searchParams.get('filters') || '').split(',');
      filterButtons.forEach((button) => {
        button.setAttribute('aria-pressed', initialFilters.includes(button.dataset.filter) ? 'true' : 'false');
        button.addEventListener('click', () => {
          const isActive = button.getAttribute('aria-pressed') === 'true';
          button.setAttribute('aria-pressed', String(!isActive));
          applySearch();
        });
      });

      searchInput.addEventListener('input', scheduleSearch);
      clearButton.addEventListener('click', () => {
        searchInput.value = '';
        applySearch();
        searchInput.focus();
      });
      suggestionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          searchInput.value = button.dataset.searchSuggestion;
          applySearch();
          searchInput.focus();
        });
      });

      const showIndex = () => {
        index.hidden = false;
        profileView.hidden = true;
        missing.hidden = true;
        profileContent.replaceChildren();
        document.title = document.title.replace(/^.+? · /, '');
      };

      const showProfile = (handle, shouldScroll = true) => {
        const template = library.querySelector(`#IngredientProfile-${CSS.escape(handle)}`);

        if (!template) {
          index.hidden = true;
          profileView.hidden = true;
          missing.hidden = false;
          if (shouldScroll) window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }

        profileContent.replaceChildren(template.content.cloneNode(true));
        index.hidden = true;
        missing.hidden = true;
        profileView.hidden = false;

        const heading = profileContent.querySelector('h1');
        if (heading) document.title = `${heading.textContent.trim()} · Kadey’s Ingredient Library`;
        if (shouldScroll) window.scrollTo({ top: 0, behavior: 'smooth' });
      };

      const route = (shouldScroll = false) => {
        const handle = new URL(window.location.href).searchParams.get('ingredient');
        if (handle) showProfile(handle, shouldScroll);
        else showIndex();
      };

      library.addEventListener('click', (event) => {
        const ingredientLink = event.target.closest('[data-ingredient-handle]');
        const backLink = event.target.closest('[data-ingredient-library-back]');

        if (ingredientLink) {
          event.preventDefault();
          const handle = ingredientLink.dataset.ingredientHandle;
          const nextUrl = getLibraryUrl();
          nextUrl.searchParams.set('ingredient', handle);
          window.history.pushState({ ingredient: handle }, '', nextUrl);
          showProfile(handle);
        } else if (backLink) {
          event.preventDefault();
          window.history.pushState({}, '', getLibraryUrl());
          showIndex();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });

      window.addEventListener('popstate', () => route(true));
      applySearch(false);
      route();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadeys-product-main"]) return;
  try {
    
  document.querySelectorAll('[data-kadeys-product]').forEach((productSection) => {
    const form = productSection.querySelector('.kk-product__form');
    const variantInput = productSection.querySelector('[data-product-variant]');
    const optionInputs = productSection.querySelectorAll('[data-product-option]');
    const variantsScript = productSection.nextElementSibling;

    if (!form || !variantInput || !optionInputs.length || !variantsScript?.matches('[data-kadeys-variants]')) return;

    const variants = JSON.parse(variantsScript.textContent);
    const price = productSection.querySelector('[data-product-price]');
    const submit = productSection.querySelector('[data-product-submit]');
    const submitLabel = productSection.querySelector('[data-product-submit-label]');

    const updateVariant = () => {
      const selectedOptions = Array.from(optionInputs).map((input) => input.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));

      if (!variant) {
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submitLabel.textContent = 'Unavailable';
        return;
      }

      variantInput.value = variant.id;
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format(variant.price / 100);
      submit.disabled = !variant.available;
      submit.setAttribute('aria-disabled', String(!variant.available));
      submitLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  });

  document.querySelectorAll('[data-kadeys-write-review]').forEach((button) => {
    button.addEventListener('click', () => {
      const reviewSection = button.closest('.kk-product-reviews');
      const judgeMeWriteButton = reviewSection?.querySelector('.jdgm-write-rev-link, [data-write-review]');

      reviewSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });

      window.setTimeout(() => {
        if (judgeMeWriteButton) {
          judgeMeWriteButton.click();
        } else {
          const widget = reviewSection?.querySelector('#judgeme_product_reviews');
          widget?.focus?.();
        }
      }, 450);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
